import { __assign } from "tslib";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getContext from 'recompose/getContext';
import { compose } from 'redux';
import Image from '../components/Image';
import onlyIf from '../hocs/onlyIf';
import { isInHandoffMode } from '../selectors';
import { getHeaderProps } from '../selectors/fixedArea';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    return __assign(__assign({}, getHeaderProps(state, isCurrentScreen)), { hide: isInHandoffMode(state) });
}
var shouldRender = function (_a) {
    var header = _a.header, hide = _a.hide;
    return !hide && !!header;
};
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps), onlyIf(shouldRender))(Image);
